// src/store/services/coach.js
import feathersClient, {
  makeServicePlugin,
  BaseModel
} from "../../feathers-client";

class ExternalFeedback extends BaseModel {
  constructor (data, options) {
    super(data, options);
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = "ExternalFeedback";
  // Define default properties here
  static instanceDefaults () {
    return {
      id: null,
      currentGap: null,
      externalToken: null,
      externalTokenExpired: null,
      endorsementInvitePrgmsId: null,
      createdAt: null,
      updatedAt: null,
      feedbackSentDate: null,
      feedbackReceivedDate: null,
      emailStatus:null
    };
  }
}
const servicePath = "external-feedback";
const servicePlugin = makeServicePlugin({
  Model: ExternalFeedback,
  service: feathersClient.service(servicePath),
  servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
});

export default servicePlugin;
